import { lazy } from 'react'

export const Workout = lazy(() => import('./v1/Workout'))
export const WorkoutV2 = lazy(() => import('./v2/WorkoutV2'))
export const WorkoutV3 = lazy(() => import('./v3/WorkoutV3'))
